import { Component } from '@theme/component';
import { productReference } from '@theme/project-utils';

/** Native link enhancement; Shopify's purchase form remains the variant authority. */
class ProductStudioQuote extends Component {
  /** @param {MouseEvent} event - Quote link activation. */
  prepareQuote(event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a');
    if (!(link instanceof HTMLAnchorElement)) return;
    const reference = productReference(this.dataset.productUrl || location.href, location.origin);
    if (!reference) return;
    const productUrl = new URL(reference.url);
    const input = this.closest('.shopify-section')?.querySelector('product-form-component input[name="id"]')
      || document.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"] input[name="id"]`);
    if (input instanceof HTMLInputElement && /^\d{1,20}$/.test(input.value)) productUrl.searchParams.set('variant', input.value);
    const quoteUrl = new URL(link.href);
    if (quoteUrl.origin !== location.origin || quoteUrl.hash !== '#ProjectInquiry') return;
    quoteUrl.searchParams.set('product_request', productUrl.href);
    quoteUrl.hash = 'ProjectInquiry';
    link.href = quoteUrl.href;
  }
}
if (!customElements.get('product-studio-quote')) customElements.define('product-studio-quote', ProductStudioQuote);
